import zhTW from "./zh_TW.json";
import enUS from "./en_US.json";

const messages = {
    "zh-TW" : zhTW ,
    "en-US" : enUS
}

export default messages;